<template>
  <div>
    <back>头像</back>
    父组件:{{ m }}
    <!-- <Son1 :value="m" @input="change"></Son1> -->

    <!-- <Son1 :value="m" @update:value="(value)=> this.m = value"></Son1> -->
    <!-- 简化 -->
    <Son1 :value.sync="m"></Son1>

    <!-- <Son1 v-model="m"></Son1> -->

    <Son2 name="lhr" age="18"></Son2>
    <div>
      <!-- <button @click="k('Form cannot be submitted yet.', $event)">测试</button> -->
      <Button size="md" type="default" @click="k('Form cannot be submitted yet.', $event)">测试</Button>
    </div>

    <!-- <div id='example-3'>
      <input type="checkbox" id="jack" value="Jack" v-model="checkedNames">
      <label for="jack">Jack</label>
      <input type="checkbox" id="john" value="John" v-model="checkedNames">
      <label for="john">John</label>
      <input type="checkbox" id="mike" value="Mike" v-model="checkedNames">
      <label for="mike">Mike</label>
      <br>
      <span>Checked names: {{ checkedNames }}</span>
    </div>

    <div id="example-6">
      <select v-model="selected" multiple style="width: 50px;">
        <option>A</option>
        <option>B</option>
        <option>C</option>
      </select>
      <br>
      <span>Selected: {{ selected }}</span>
    </div> -->
  </div>
</template>
<script>
import Son1 from 'packages/study/son1'
import Son2 from 'packages/study/son2'

export default {
  components: {
    Son1,
    Son2
  },
  data () {
    return {
      m: 100,
      checkedNames: [],
      selected: []
    }
  },
  methods: {
    change (value) {
      console.log(value)
      this.m += value
    },
    k (message, e) {
      console.log(message, e)
    }
  }
}
</script>
